import React from "react";
import Button from "./index";

const AccentButton = (props) => (
  <Button buttonType="button-accent" {...props} />
);
export default AccentButton;
